import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Base from "../../base/views/base";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { editUserProfile, getUserProfile } from "../helper/dashboardHelper";
import "@dsalvagni/react-profile-picture/dist/ProfilePicture.css";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function MyAccount() {
  const classes = useStyles();
  const [accountData, setState] = useState({
    userId: "",
    userEmail: "",
    firstName: "",
    lastName: "",
    mobileNo: "",
    profilePic: "",
  });
  const [errors, setErrors] = React.useState({});

  const updateField = (e) => {
    setState({
      ...accountData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = (fieldValues = accountData) => {
    let temp = {};
    if ("firstName" in fieldValues) {
      temp.firstName =
        fieldValues.firstName === "" ? "First Name is required" : "";
    }
    if ("lastName" in fieldValues) {
      temp.lastName =
        fieldValues.lastName === "" ? "Last Name is required" : "";
    }

    if ("mobileNo" in fieldValues) {
      temp.mobileNo =
        fieldValues.mobileNo.length < 10
          ? "Invalid mobile no. 10 digits required"
          : fieldValues.mobileNo.length > 10
          ? "Invalid mobile no. exceeded 10 digits"
          : "";
    }

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    getUserProfile(sessionStorage.getItem("userId")).then((res) => {
     
      var base64string = "";

      if (res.data.profilepic) {
        var binary = "";
        var bytes = res.data.profilepic
          ? new Uint8Array(res.data.profilepic.data)
          : "";
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        base64string = "data:image/png;base64," + window.btoa(binary);
      }
      setState({
        ...accountData,
        userId: sessionStorage.getItem("userId"),
        userEmail: res.data.useremailid,
        firstName: res.data.firstname,
        lastName: res.data.lastname,
        mobileNo: res.data.mobileno,
        profilePic: base64string, // need to change
      });
      setErrors({});
    });
    // eslint-disable-next-line
  }, []);

  const SaveAccount = () => {
    if (validate()) {
      editUserProfile(accountData)
        .then((res) => {
          if (res && res !== null) {
            setState({
              ...accountData,
              userId: sessionStorage.getItem("userId"),
              firstName: res.data.firstname,
              lastName: res.data.lastname,
              mobileNo: res.data.mobileno,
              profilePic: "",
            });
          }
        })
        .catch((err) => {});
    }
  };

  return (
    <>
      <Base showBaseMenu={false} hideDrawer={true} hidePharmacyButton={true}>
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <Container maxWidth="xs" className={classes.Appcss}>
            <div className={classes.paper}>
              <Typography component="h1" variant="h5">
                My Account
              </Typography>
              <div className={classes.form}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      required
                      value={accountData.userId}
                      autoComplete="uid"
                      name="userId"
                      variant="outlined"
                      fullWidth
                      id="userId"
                      label="User Name"
                      autoFocus
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      value={accountData.userEmail}
                      autoComplete="uid"
                      name="userEmail"
                      variant="outlined"
                      fullWidth
                      id="userEmail"
                      label="Email"
                      autoFocus
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      value={accountData.firstName}
                      onChange={updateField}
                      autoComplete="fname"
                      name="firstName"
                      variant="outlined"
                      fullWidth
                      id="firstName"
                      label="First Name"
                      autoFocus
                      {...(errors.firstName && {
                        error: true,
                        helperText: errors.firstName,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      value={accountData.lastName}
                      onChange={updateField}
                      variant="outlined"
                      fullWidth
                      id="lastName"
                      label="Last Name"
                      name="lastName"
                      autoComplete="lastName"
                      {...(errors.lastName && {
                        error: true,
                        helperText: errors.lastName,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      value={accountData.mobileNo}
                      onChange={updateField}
                      variant="outlined"
                      fullWidth
                      id="mobileNo"
                      label="Mobile No"
                      name="mobileNo"
                      autoComplete="mobileNo"
                      type="number"
                      {...(errors.mobileNo && {
                        error: true,
                        helperText: errors.mobileNo,
                      })}
                    />
                  </Grid>
                </Grid>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={SaveAccount}
                    style={{ width: "20vw", backgroundColor: "rgb(22, 177, 255)" }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Container>
      </Base>
      <LandingPageFooter />
    </>
  );
}
